import React from 'react';

import {
  Wrapper,
  IconContainer,
  MainContainer,
  SelectContainer,
  IconSMS,
  GlobalStyle,
} from './styles';

interface Contact {
  info: string;
  select?: ISelect;
  selectFunction: Function;
  onkeypress: Function;
  isSelected: boolean;
}

const SmsCard: React.FC<Contact> = ({
  info,
  select,
  selectFunction,
  onkeypress,
  isSelected,
}) => {
  return (
    <Wrapper
      tabIndex={0}
      className={isSelected ? 'selected' : ''}
      onClick={() => selectFunction('sms', select?.typeContact)}
      onKeyPress={(e) => onkeypress(e)}
    >
      <GlobalStyle />
      <IconContainer>
        <IconSMS />
      </IconContainer>
      <MainContainer>
        <span>Enviar o código por SMS para o número:</span>

        <span className='info'>{info}</span>
      </MainContainer>
      <SelectContainer
        selected={isSelected}
        onClick={() => selectFunction('sms', select?.typeContact)}
      >
        <span />
      </SelectContainer>
    </Wrapper>
  );
};

export default SmsCard;
